<script>
  import { Loading, SkeletonText } from "carbon-components-svelte";

  export let shareCat01 = 42;
  export let shareCat02 = 42;
  export let shareCat03 = 16;
  export let share = true;
  export let category = "Define Category";
  export let loading = false;

  export let cat01 = "Main Apps";
  export let cat02 = "Support Apps";
  export let cat03 = "Unwanted Apps";
</script>

<div class="tile_wrapper">
  <div class="tile_heading bold">{category}</div>
  <div class="tile_values">
    {#if loading === true}
      {#each Array(3) as _}
        <div class="tile_value">
          <SkeletonText />
        </div>
      {/each}
    {:else}
      <div class="tile_value">
        <div class="tile_value_left">
          <img
            src="/img/assistant/icons/arrow_right_dark.svg"
            alt="arrow_right"
          />
          <div class="text">{cat01}</div>
        </div>
        <div class="tile_value bold">
          {shareCat01}
          {#if share === true}
            %
          {/if}
        </div>
      </div>
      <div class="tile_value">
        <div class="tile_value_left">
          <img
            src="/img/assistant/icons/arrow_right_dark.svg"
            alt="arrow_right"
          />
          <div class="text">{cat02}</div>
        </div>
        <div class="tile_value bold">
          {shareCat02}
          {#if share === true}
            %
          {/if}
        </div>
      </div>
      <div class="tile_value">
        <div class="tile_value_left">
          <img
            src="/img/assistant/icons/arrow_right_dark.svg"
            alt="arrow_right"
          />
          <div class="text">{cat03}</div>
        </div>
        <div class="tile_value bold">
          {shareCat03}
          {#if share === true}
            %
          {/if}
        </div>
      </div>
    {/if}
  </div>

  <!-- {/if} -->
  <div class="button_section">
    <slot />
  </div>
</div>

<style>
  .tile_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: white;
    padding: 1rem;
    border-radius: 0.5rem;
  }

  .tile_values {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem 0;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
  }

  .text {
    display: flex;
    align-items: center;
  }

  .tile_value {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 1rem;
    align-items: center;
  }

  .tile_value_left {
    display: flex;
    gap: 0.5rem;
  }

  .button_section {
    display: flex;
    gap: 0.5rem;
  }
</style>
